import { call } from 'redux-saga/effects';

import { branch, pipe } from '../../../sagas/Helpers';
import * as UseCaseHelpers from '../helpers';

import * as TrackFeedbackHelpers from './helpers';

export function* trackFeedback(action) {
  yield call(
    pipe([
      branch(
        UseCaseHelpers.isAPS,
        TrackFeedbackHelpers.APSFeedback,
        TrackFeedbackHelpers.stationFeedback,
      ),
      TrackFeedbackHelpers.triggerFeedbackHappened,
    ]),
    action,
  );
}
